import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApiService} from "../../../services/api.service";
import {UserService} from "../../../services/user.service";
import {Router} from "@angular/router";
import {PopupService} from "../../../services/popup.service";


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  form: FormGroup;
  errorMessages: any;

  constructor(
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    private userService: UserService,
    private routerService: Router,
    private popup: PopupService,
  ) {

    this.form = formBuilder.group(
      {
        email: ["",
          [Validators.required,],
        ],
      },
      {updateOn: "blur"}
    );

    this.errorMessages = {
      email: [
        {
          type: "required",
          message: "Email is required"
        },
      ],
    };

  }

  ngOnInit(): void {
  }

  /**
   * @desc Login form handler
   */
  processRecover() {
    let params = {
      email: this.form.value.email
    };

    this.getForgotEmail(params);
  }

  /**
   * @desc Call the username and password authentication via API
   * @param params
   * @private
   */
  private getForgotEmail(params) {
    this.userService.forgotPassword(params).then(response => {
      // Email successful - show state
      console.log(response)
      let message = response.data.message;
      this.popup.success("Password reset", message, "OK");
      this.routerService.navigate(["/login"]);
    }).catch(error => {
      let message = error.response.data.message;
      this.popup.error("Something went wrong.", message, "OK");
    })
  }
}
